import { createSelector } from '@reduxjs/toolkit';
import { rootSelector } from '../root/root.selectors';

export const magnifierSelector = createSelector(rootSelector, state => state.magnifier);

export const isMagnifierActiveSelector = createSelector(magnifierSelector, state => state.isActive);
